import { render } from "./CRMDashboardCRMWhatsappConversationFeedbacksComponent.vue?vue&type=template&id=78bf82d8&scoped=true"
import script from "./CRMDashboardCRMWhatsappConversationFeedbacksComponent.vue?vue&type=script&lang=js"
export * from "./CRMDashboardCRMWhatsappConversationFeedbacksComponent.vue?vue&type=script&lang=js"

import "./CRMDashboardCRMWhatsappConversationFeedbacksComponent.vue?vue&type=style&index=0&id=78bf82d8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-78bf82d8"]])

export default __exports__